import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { styled, FormControl, FormLabel } from "@mui/material";
import { TextareaAutosize } from "@mui/base";
import { PALETTE } from "../../Theme/Palette";

const BaseText = styled("textarea")((props) => ({
  boxSizing: "border-box",
  width: "100%",
  backgroundColor: PALETTE.primary,
  color: PALETTE.third,
  padding: "0.24rem 0.2rem",
  textAlign: "right",
  direction: "rtl",
  resize: "none",
  border: "none",
  overflow: "auto",
  outline: "none",
  fontSize: 14,
  borderStyle: "none",
  borderRadius: "0.5rem",
  fontWeight: "bold",
  scrollbarColor: `#4C466F #ffffff`,
  scrollbarWidth: "thin",
  backgroundClip: "padding-box",
  cursor: "auto",
  ...props.style,
  "&::-webkit-scrollbar": {
    width: "7px",
    padding: "1rem",
  },
  "&::-webkit-scrollbar-track": {
    boxShadow: "#FFFFFF",
    background: "#FFFFFF",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#4C466F",
    padding: "0 40px ",
    margin: "0 1rem",
    borderRadius: "10px",
  },
  "&::placeholder": {
    color: "#bdbdc2",
    fontWeight: "none",
    fontSize: 14,
  },
  "&:disabled , &.Mui-disabled": {
    color: PALETTE.sixth,
    backgroundColor: PALETTE.fifth,
  },
}));

function BaseTextArea({
  label,
  value,
  id,
  disabled = false,
  labelFlex,
  flex,
  placeholder = "",
  minRows = 1,
  maxRows = 3,
  resize = "vertical",
  onChange = () => {},
  error = false,
  ...props
}) {
  const [showSubmitError, setShowSubmitError] = useState(
    (!value || value === undefined || value === "") && error
  );

  useEffect(() => {
    setShowSubmitError((!value || value === undefined || value === "") && error);
  }, [error, value]);

  return (
    <FormControl
      my={0.5}
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        minWidth: "100%",
        maxWidth: "100%",
        flexWrap: "wrap",
      }}
    >
      <FormControl
        sx={{
          flex: flex,
          flexWrap: "wrap",
          boxSizing: "border-box",
          background: disabled ? PALETTE.fifth : PALETTE.primary,
          border: `1px solid ${
            disabled ? "transparent" : showSubmitError ? PALETTE.ninth : PALETTE.fourth
          }`,
          borderRadius: "10px",
          padding: "0.15rem 0.35rem",
          paddingBottom: "0.45rem",
        }}
        {...props}
      >
        <BaseText
          value={value}
          disabled={disabled}
          maxRows={maxRows}
          minRows={minRows}
          placeholder={placeholder}
          onChange={onChange}
          sx={{ resize: `${resize} !important` }}
          id="textarea-auto-size"
          native="true"
          as={TextareaAutosize}
          {...props}
        />
      </FormControl>
      {label && (
        <FormLabel
          htmlFor={id}
          sx={{
            flex: labelFlex,
            textAlign: "right",
            color: "#4C466F !important",
            fontSize: 14,
          }}
        >
          {label}
        </FormLabel>
      )}
    </FormControl>
  );
}

BaseTextArea.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default BaseTextArea;
